import React from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';
import { clinicInfo } from '../../mock';

export const Header = ({ isMenuOpen, setIsMenuOpen, scrollToSection }) => (
  <header data-testid="site-header" className="absolute top-0 w-full z-50">
    <div className="container mx-auto px-4 py-3 md:py-6">
      <div className="flex items-center justify-between">
        {/* Desktop logo - no black background */}
        <div className="flex items-center space-x-4">
          <img
            src={clinicInfo.logo}
            alt="FAVOR HCS Logo"
            className="hidden md:block h-64 lg:h-96 w-auto drop-shadow-[0_6px_16px_rgba(74,44,32,0.12)] transition-transform duration-500 hover:scale-[1.02]"
          />
        </div>

        <nav className="hidden md:flex items-center space-x-8">
          {['home', 'about', 'services', 'insurance', 'contact'].map((section) => (
            <button
              key={section}
              onClick={() => scrollToSection(section)}
              className="text-darkBrown hover:text-primaryOrange transition-colors font-bold text-lg drop-shadow-md capitalize"
            >
              {section}
            </button>
          ))}
          <Button
            data-testid="book-appointment-nav-btn"
            onClick={() => scrollToSection('appointment')}
            className="bg-primaryOrange hover:bg-accentOrange text-white shadow-xl text-lg px-8"
          >
            Book Appointment
          </Button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-darkBrown bg-white rounded-full p-2.5 shadow-lg"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMenuOpen && (
        <nav data-testid="mobile-menu" className="md:hidden mt-3 pb-3 space-y-2 animate-in fade-in slide-in-from-top-2 bg-white rounded-2xl shadow-2xl p-5">
          {['home', 'about', 'services', 'insurance', 'contact'].map((section) => (
            <button
              key={section}
              onClick={() => scrollToSection(section)}
              className="block w-full text-left text-darkBrown hover:text-primaryOrange transition-colors font-bold py-2 text-base capitalize"
            >
              {section}
            </button>
          ))}
          <Button
            onClick={() => scrollToSection('appointment')}
            className="w-full bg-primaryOrange hover:bg-accentOrange text-white shadow-xl text-base mt-2"
          >
            Book Appointment
          </Button>
        </nav>
      )}
    </div>
  </header>
);
